import repository from 'client/repository';
import swipeTypes from 'areas/swipes/domain/swipeTypes';
import alertActions from 'areas/alert/actions';
import progressActions from 'areas/progress/actions';
import m from 'messages';

import {
    requestCardData,
    receiveCardData,
    requestCardDataFailed,
    showCardholderPage
} from 'areas/cards/actions';
import logService from 'utilities/logging/logService';

/*
 * This is the action that gets performed when a persons card is read during a swipe in operation
 */
export default function (qrCode, cardHolderPageContext) {

    const actionPrefix = 'QR_LOOKUP';

    function failure(error) {
        return { type: `${actionPrefix}_FAILURE`, error };
    }

    return async dispatch => {
        try {

            dispatch(progressActions.report(m.cards.readingCard));

            // Signal and do the load of the card data
            dispatch(requestCardData(qrCode));
            dispatch(progressActions.report(m.cards.fetchingCard));

            const includeFatigueInfo = true;
            const qrData = await repository.cards.getCardDataByQR(qrCode, true, includeFatigueInfo);

            if (!Boolean(qrData)) {

                dispatch(requestCardDataFailed(qrCode, m.cards.cardNotFoundMessage));
                dispatch(alertActions.warn(m.cards.cardNotFoundMessage));

            } else {
                qrData.cardData.swipeType = swipeTypes.QR;
                qrData.cardData.dateRetrieved = new Date().toISOString();
                logService.info("Fetched Card data", qrData);
                // Signal the card data has been received
                dispatch(receiveCardData(qrCode, qrData));

                dispatch(showCardholderPage(qrCode, cardHolderPageContext));
            }

            dispatch(progressActions.hide());
        }
        catch (error) {
            // Generic error handler, a number of different errors could have happened here
            dispatch(alertActions.error(error.failureReason || error.toString()));
            dispatch(failure(error.failureReason || error.toString()));
            dispatch(progressActions.hide());
        }
    };
}
